module.exports = __webpack_public_path__ + "static/media/rexoz shot 2.c579c53a.webp";